export default __webpack_public_path__ + "static/media/singh.a891a5c9.svg";